import { Component, OnInit, Input, Output, EventEmitter } from '@angular/core';

import { CommonService } from 'src/app/shared/services/common.service';
import { BaseFormGroup } from 'src/app/shared/form-input-components/base-form-group';
import { FormGroup, FormArray, Validators, FormControl } from '@angular/forms';
import { arrayNotEmptyValidator } from '../../../shared/validators/array-not-empty-validator';
import { UtilService } from 'src/app/shared/services/util.service';
import { MergeBookingService } from './merge-booking.service';
import { CreateBookingService } from '../../create-booking/create-booking.service';



@Component({
  selector: 'app-merge-bookings',
  templateUrl: './merge-bookings.component.html',
  styleUrls: ['./merge-bookings.component.scss']
})
export class MergeBookingsComponent extends BaseFormGroup implements OnInit {

  @Input() bookings: any[];
  @Output() closeCallback = new EventEmitter();
  @Output() successCallback = new EventEmitter();
  @Input() miscelleneousConfig: any;
  public config: any;
  public stepperDetails: any[];
  public activeStep = 0;
  public riderMap = {};
  public isLoading = true;
  public bookingFormConfig: any;
  public riderFormConfig: any;
  public etsData: any;
  public singleBookingDetails: any;
  public isBookingDetailsVisible: boolean;
  public stepperFormArray: FormArray;
  public mergedRequestData: any;
  mergerFailed = false;
  mergerError = '';
  cancelMergeBooking = false;

  constructor(private commonService: CommonService, private utilService: UtilService, private mergeBookingService: MergeBookingService
    ,         private createBookingService: CreateBookingService) {
    super();
  }

  ngOnInit() {
    this.commonService.getEtsData().subscribe((response) => {
      this.etsData = response;
    });
    this.commonService.fetchConfig().subscribe((response) => {
      this.config = this.commonService.getConfigForElementKey(response, 'Merge Bookings Pop-Up');
      this.bookingFormConfig = this.commonService.getConfigForElementKey(this.config, 'Booking Details');
      this.riderFormConfig = this.commonService.getConfigForElementKey(this.config, 'Rider Details');
      this.setupForm();
      this.setupStep1();
      this.setupStep2();
      this.setupStepper();
      this.isLoading = false;
    });
    this.createBookingService.fetchEscortConfig().subscribe(res => {
        this.createBookingService.startTime.next(res[0].escortAssigGenderConfig[0].escortAssigTimeConfig.startTime);
        this.createBookingService.endTime.next(res[0].escortAssigGenderConfig[0].escortAssigTimeConfig.endTime);
        this.createBookingService.genderArrays.next(res[0].escortAssigGenderConfig[0].gender);
       });

  }

  setupForm() {
    const bookingDetails =  new FormGroup({});
    this.constructForm(bookingDetails, this.bookingFormConfig.elementConfigList, (field) => {
      if (!field.config.elementType) {
        return true;
      }
      return false;
    });
    const stopsArray =  new FormArray([]);
    this.formDetails = new FormGroup({
      bookingDetails,
      stopsArray,
    });
  }

  setupStep1() {
    const optionsToMap = ['spotBookingType', 'vehicleType', 'otherVehicleType', 'paymentType', 'vendor', 'cab'];
    const optionsAccumalator = {};
    for (const booking of this.bookings) {
      for (const optionToMap of optionsToMap) {
        if (!optionsAccumalator[optionToMap]) {
          optionsAccumalator[optionToMap] = {};
        }
        if (!booking[optionToMap]) {
          continue;
        }
        if (optionToMap === 'vendor') {
          optionsAccumalator[optionToMap][booking[optionToMap].guid] = true;
        } else if (optionToMap === 'cab') {
          optionsAccumalator[optionToMap][booking.cab.guId] = true;
        } else {
          optionsAccumalator[optionToMap][booking[optionToMap]] = true;
        }
      }
    }

    const bookingDetailsForm = this.formDetails.get('bookingDetails');
    if (bookingDetailsForm instanceof FormGroup) {
      for (const optionToMap of optionsToMap) {
        if (Object.keys(optionsAccumalator[optionToMap]).length === 1) {
          bookingDetailsForm.get(optionToMap).setValue(Object.keys(optionsAccumalator[optionToMap])[0]);
        }
      }
    }
  }

  getRiderTempId(rider) {
    return rider.emplGuid || (rider.email + rider.name + rider.phone);
  }

  setupStep2() {
    const stopsFormArray = this.formDetails.get('stopsArray');
    if (!(stopsFormArray instanceof FormArray)) {
      return;
    }

    let stops = [];
    for (const booking of this.bookings) {
      if (booking.spotBookingType === 'Airport PickUp') {
        booking.stops[0].isAirport = true;
      } else if (booking.spotBookingType === 'Airport Drop' || booking.spotBookingType === 'Airport To Airport') {
        booking.stops[booking.stops.length - 1].isAirport = true;
      }
      else if(booking.spotBookingType==='Bus Station Pickup' || booking.spotBookingType === 'Railway Station Pickup')
      {
        booking.stops[0].isBusRailway = true;
      }
      else if(booking.spotBookingType==='Bus Station Drop' || booking.spotBookingType === 'Railway Station Drop')
      {
        booking.stops[booking.stops.length - 1].isBusRailway = true;
      }
      stops = stops.concat(booking.stops);
    }
    const uniqueGeoCords = new Set();
    // stops = stops.filter((stop) => {
    //   if (!uniqueGeoCords.has(stop.geoCord)) {
    //     uniqueGeoCords.add(stop.geoCord);
    //     return true;
    //   }
    //   return false;
    // });


    const tempRiderMap = {};
    // The tempRiderMap logic is used to handle the same rider in multiple bookings
    let lastStopTime;
    stops.forEach((stop, stopIndex) => {
      if (stop.time) {
        lastStopTime = stop.time;
        stop.dateTime = this.utilService.getMoment(stop.time);
        stop.timeStr = this.utilService.converDateTimeToDisplayTime(stop.time);
      }
      stop.riders.forEach((rider) => {
        const tempId = this.getRiderTempId(rider);
        if (!tempRiderMap[tempId]) {
          const uniqueEmpId = this.utilService.generateUuid();
          const riderClone = this.utilService.deepCopy(rider);
          delete riderClone.personId;
          delete riderClone.riderId;
          riderClone.uniqueEmpId = uniqueEmpId;
          tempRiderMap[tempId] = riderClone;
          this.riderMap[uniqueEmpId] = riderClone;
        }

        if (rider.boardingType === 'Drop') {
          tempRiderMap[tempId].dropPointId = stop.id;
        } else if (rider.boardingType === 'PickUp' && tempRiderMap[tempId].pickupPointId === undefined) {
          tempRiderMap[tempId].pickupPointId = stop.id;
        }
      });
    });

    stops.sort((stop1, stop2) => {
      if (!stop1.dateTime && !stop2.dateTime) {
        return 0;
      } else if (!stop1.dateTime) {
        return 1;
      } else if (!stop2.dateTime) {
        return -1;
      } else {
        return stop1.dateTime.diff(stop2.dateTime, 'minutes');
      }
    });

    lastStopTime = undefined;
    stops.forEach((stop, stopIndex) => {
      if (stop.time) {
        lastStopTime = stop.time;
      } else {
        stop.dateTime = this.utilService.getMoment(lastStopTime);
      }
      const stopForm: any = this.createStopForm((stopIndex === stops.length - 1));
      stopForm.patchValue({
        address: {
          isAirport: stop.isAirport,
          isSaved: true,
          address: stop.address,
          addressType: stop.addressType,
          geoArea: stop.geoArea,
          geoCord: stop.geoCord,
          isBusRailway:stop?.isBusRailway|| false
        },
        date: stop.dateTime ? [stop.dateTime] : null,
        time: stop.timeStr
      });
      const riderFormArray = stopForm.get('riders');
      if (stopIndex !== stop.length - 1 && riderFormArray instanceof FormArray) {
        stop.riders.forEach((rider) => {
          const tempId = this.getRiderTempId(rider);
          const riderCache = tempRiderMap[tempId];
          const riderInfo = this.riderMap[riderCache.uniqueEmpId];
          if ((rider.boardingType === 'PickUp' && riderCache.pickupPointId === stop.id) ||
            (rider.boardingType === 'Drop' && riderCache.dropPointId === stop.id)) {
            const riderForm = this.createRiderForm();
            riderForm.patchValue({
              name: riderInfo.uniqueEmpId,
              mobile: riderInfo.mobile,
              boardingType: rider.boardingType,
              gender: rider.gender,
            });
            riderFormArray.push(riderForm);
          }
        });
      }
      stopsFormArray.push(stopForm);
    });
    const stopArray=this.formDetails.get('stopsArray')
    if (stopArray instanceof FormArray){
      const control = stopArray.controls[stopArray.length - 1].get('time');
      control.setValue('')
      control.setErrors(null);
      control.clearValidators();
      control.updateValueAndValidity();
    }
  }

  createStopForm(isLastStop) {
    const validators = !isLastStop ? [Validators.required] : null;
    const formGroup: any = new FormGroup({
      time: new FormControl('', validators),
      address: new FormControl('', [Validators.required]),
      date: new FormControl('', [Validators.required]),
    });
    formGroup.addControl('riders', new FormArray([], [arrayNotEmptyValidator]));
    return formGroup;
  }

  createRiderForm() {
    return new FormGroup({
      name: new FormControl('', [Validators.required]),
      mobile: new FormControl('', ),
      boardingType: new FormControl('', [Validators.required]),
      gender: new FormControl(''),
      pointType: new FormControl('')
    });
  }

  cancelCallback() {
    this.closeCallback.emit();
  }

  setupStepper() {
    this.stepperDetails = [
      {
        label: this.commonService.getConfigForElementKey(this.config, 'Booking Details').config.displayName,
      },
      {
        label: this.commonService.getConfigForElementKey(this.config, 'Rider Details').config.displayName
      },
      {
        label: 'Confirm request'
      }
    ];
    this.stepperFormArray = new FormArray([
      this.formDetails.get('bookingDetails'),
      this.formDetails.get('stopsArray')
    ]);
  }

  onStepChange(step) {
    this.activeStep = step;
  }

  // onStepClick(step) {
  //   if (step === this.activeStep) {
  //     return;
  //   } else if (step < this.activeStep) {
  //     this.onStepChange(step);
  //   } else {
  //     if (step === 1) {
  //       this.goToRiderDetails();
  //     }
  //   }
  // }

  goToRiderDetails() {
    if (this.formDetails.get('bookingDetails').valid) {
      this.onStepChange(1);
    } else {
      this.markFormGroupDirty(this.formDetails);
    }
  }

  goToConfirmRequest() {
      
    if (!this.formDetails.get('bookingDetails').valid || !this.formDetails.get('stopsArray').valid) {
      this.markFormGroupDirty(this.formDetails);
    } else {
      this.mergedRequestData = this.mergeBookingService.getMergeRequest(this.bookings, this.formDetails, this.riderMap);
      this.stepperDetails[1].completed = true;
      this.onStepChange(2);
    }
  }

  onSubmitClick() {

    this.isLoading = true;
    this.mergeBookingService.mergeBookings(this.mergedRequestData).subscribe((response) => {
      this.isLoading = false;
      this.successCallback.emit(response);
    }, error => {
      this.mergerFailed = true;
      this.mergerError = error.error.message;
      this.isLoading = false;
    });
  }

  showBookingDetails(booking) {
    this.singleBookingDetails = booking;
    this.isBookingDetailsVisible = true;
  }

  handleCloseBookingDetails() {
    this.singleBookingDetails = null;
    this.isBookingDetailsVisible = false;
  }

}
